<template>
  <div class="privacy" v-bind:style="{ paddingBottom: '96px' }">

    <NavigationBar>
      <template v-slot:left>
        <div v-if="canGoBack()">
          <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack" data-testid="nav-back">
        </div>
        <div v-else>
        </div>
      </template>
      <template v-slot:center>
        <span data-testid="accessibility-title">{{ $t('home.footer_accessibility') }}</span>
      </template>
    </NavigationBar>

    <div v-if="userlang === 'de'">

      <div style="margin-top: 48px;">

        <div id="paragraph_1">
          <h3>Barrierefreiheitserklärung für Teamtip</h3>
          <p>
          Die Betreiber dieser Anwendung sind bemüht, Teamtip im Einklang mit dem Barrierefreiheitsstärkungsgesetz (BFSG) sowie der Verordnung zum Barrierefreiheitsstärkungsgesetz (BFSGV) barrierefrei zugänglich zu machen.
          </p>
        </div>

        <div id="paragraph_2">
          <h3>Stand der Vereinbarkeit mit den Anforderungen</h3>
          <p>
            Diese Anwendung ist <b>teilweise barrierefrei</b>.
          </p>
          <p>
          Sie entspricht teilweise den Anforderungen des BFSG in Verbindung mit der BFSGV.
          </p>
          <p>
          Wir arbeiten kontinuierlich daran, bestehende Barrieren zu identifizieren und zu reduzieren.
          </p>
        </div>

        <div id="paragraph_3">
          <h3>Nicht barrierefreie Inhalte</h3>
          <h6>Die nachfolgenden Inhalte sind derzeit noch nicht barrierefrei:</h6>
          <div style="margin-left: 20px; margin-bottom: 0px; margin-top: 0px;">
            <p>1.	Einzelne Bedienelemente sind für Screenreader nicht korrekt ausgezeichnet.</p>
            <p>2.	Farbkontraste entsprechen teilweise nicht den Mindestanforderungen.</p>
            <p>3.	Texte und Bedienelemente sind nicht immer per Tastatur bedienbar.</p>
            <p>4.	Videos oder eingebundene Inhalte enthalten keine Untertitel bzw. Transkripte.</p>
          </div>
        </div>

        <div id="paragraph_4">
          <h3>Erstellung dieser Erklärung</h3>
          <p>
            Diese Erklärung wurde am 01.07.2025 erstellt. Die Bewertung beruht auf einer Selbstbewertung anhand der Anforderungen des BFSG und der zugrunde liegenden WCAG-Kriterien.
          </p>
        </div>

        <div id="paragraph_5">
          <h3>Feedback und Kontakt</h3>
          <p>
            Wenn Sie auf Barrieren stoßen oder Verbesserungsvorschläge haben, kontaktieren Sie uns bitte unter:
          </p>
          <ul>
            <li>E-Mail: <a href="mailto:kontakt@teamtip.net" data-testid="accessibility-email">kontakt@teamtip.net</a></li>
            <li>Betreff: Barrierefreiheit</li>
            <li>Postanschrift: SPM Sportplatz-Media GmbH, Schleidenstraße 3, 22083 Hamburg</li>
          </ul>
        </div>

        <div id="paragraph_6">
          <h3>Marktüberwachungsbehörde</h3>
          <p>
            Sollte auch nach Ihrer Kontaktaufnahme keine zufriedenstellende Lösung gefunden werden, können Sie sich an die zuständige Marktüberwachungsbehörde wenden:
          </p>
          <p>
            <b>Marktüberwachungsstelle der Länder für die Barrierefreiheit von Produkten und Dienstleistungen (MLBF)</b><br><br>
            Offizielle BFSG-Informationsseite der Bundesfachstelle: <a target="_blank" href="https://www.bundesfachstelle-barrierefreiheit.de/DE/Fachwissen/Produkte-und-Dienstleistungen/Barrierefreiheitsstaerkungsgesetz/FAQ/faq" data-testid="legal-link">https://www.bundesfachstelle-barrierefreiheit.de/DE/Fachwissen/Produkte-und-Dienstleistungen/Barrierefreiheitsstaerkungsgesetz/FAQ/faq</a><br>
          </p>
        </div>
        
        </div>

    </div>

    <div v-else>

      <div style="margin-top: 48px;">

        <div id="paragraph_1">
          <h3>Declaration of accessibility for Teamtip</h3>
          <p>
          The operators of this application strive to make Teamtip accessible in accordance with the Barrier-Free Accessibility Act (BFSG) and the Barrier-Free Accessibility Act Ordinance (BFSGV).
          </p>
        </div>

        <div id="paragraph_2">
          <h3>Status of compatibility with the requirements</h3>
          <p>
            This application is partially accessible. It partially complies with the requirements of the BFSG in conjunction with the BFSGV. We are continuously working to identify and reduce existing barriers.
          </p>
        </div>

        <div id="paragraph_3">
          <h3>Non-accessible content</h3>
          <h6>The following content is currently not yet accessible:</h6>
          <div style="margin-left: 20px; margin-bottom: 0px; margin-top: 0px;">
            <p>1.	Individual controls are not correctly labeled for screen readers.</p>
            <p>2.	Some color contrasts do not meet the minimum requirements.</p>
            <p>3.	Texts and control elements cannot always be operated using the keyboard.</p>
            <p>4.	Videos or embedded content do not contain subtitles or transcripts.</p>
          </div>
        </div>

        <div id="paragraph_4">
          <h3>Preparation of this declaration</h3>
          <p>
            This statement was created on July 1, 2025.<br>The assessment is based on a self-assessment using the requirements of the BFSG and the underlying WCAG criteria.
          </p>
        </div>

        <div id="paragraph_5">
          <h3>Feedback and contact</h3>
          <p>
            If you encounter barriers or have suggestions for improvement, please contact us at
          </p>
          <ul>
            <li>Email: <a href="mailto:kontakt@teamtip.net" data-testid="accessibility-email">kontakt@teamtip.net</a> </li>
            <li>Subject: Accessibility</li>
            <li>Postal address: SPM Sportplatz-Media GmbH, Schleidenstraße 3, 22083 Hamburg</li>
          </ul>
        </div>

        <div id="paragraph_6">
          <h3>Market surveillance authority</h3>
          <p>
            If no satisfactory solution can be found even after you have contacted us, you can contact the relevant market surveillance authority:
          </p>
          <p>
          Market Surveillance Authority of the Federal States for the Accessibility of Products and Services (MLBF)
          </p>
          <p>
            Official BFSG information page of the Federal Office: <a target="_blank" href="https://www.bundesfachstelle-barrierefreiheit.de/DE/Fachwissen/Produkte-und-Dienstleistungen/Barrierefreiheitsstaerkungsgesetz/FAQ/faq" data-testid="legal-link">https://www.bundesfachstelle-barrierefreiheit.de/DE/Fachwissen/Produkte-und-Dienstleistungen/Barrierefreiheitsstaerkungsgesetz/FAQ/faq</a><br>
          </p>
        </div>

      </div>
      
    </div>

  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar'

export default {
  name: 'BetgamePrivacy',
  components: { NavigationBar },
  computed: {
    userlang() {
      return this.$store.state.language
    }
  },
  methods: {
    goBack () {
      if (this.$store.getters.loggedIn) {
        this.$router.push({ name: 'profile' }).catch(err => {})
      } else {
        this.$router.go(-1)
      }
    },
    canGoBack () {
      return window.history && window.history.length > 1
    }
  }
}

</script>

<style lang="scss" scoped>
.privacy {
  h1 {
    font-weight: 600;
    font-size: 1.3em;
    color: black;
  }
  h3 {
    font-weight: 500;
    font-size: 1.2em;
  }
  h5 {
    font-weight: 300;
    font-size: 1.1em;
  }
  h6 {
    font-weight: 200;
    font-size: 1.0em;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
  }
  p {
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 100;
    font-size: 0.9em;
  }
  a {
    word-break: break-word;
  }
  ul > li {
    font-weight: 100;
    font-size: 0.9em;
    color: #5F5D61;
  }
}
</style>
